import useGetCurrentCustomerData from 'hooks/Authentication/useGetCurrentCustomerData';
import { useGrowthABExperimentsState } from 'hooks/useAssignGrowthABGroups';
import { ABTest } from 'types/growthExperiments.types';
import { SubscriptionPlanNameEnum } from 'types/users.types';

const excludedPlans = [
  SubscriptionPlanNameEnum.taxes1,
  SubscriptionPlanNameEnum.taxes12,
  SubscriptionPlanNameEnum.max1,
  SubscriptionPlanNameEnum.max12,
  SubscriptionPlanNameEnum.pro_max1,
  SubscriptionPlanNameEnum.pro_max12,
  SubscriptionPlanNameEnum.small_max1,
  SubscriptionPlanNameEnum.small_max12,
];

export const useShouldShowTaxAdvisor = (): boolean => {
  const { data: user } = useGetCurrentCustomerData();
  const { experiments } = useGrowthABExperimentsState();

  return (
    !!user &&
    experiments.AITA_ONLY_ENTRYPOINT === ABTest.A &&
    !excludedPlans.includes(user.subscriptionPlan.planInternalName)
  );
};
